import { InputBase, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

const CustomInput = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    borderRadius: 8,
    position: 'relative',
    // border: `1px solid #08C4BB`,
    fontSize: 12,
    padding: '10px 12px',
    height: '15px',
  },
}))

export default CustomInput
